var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1.9V0.5H10.5V1.9H14V3.3H12.6V13.8C12.6 13.996 12.5323 14.1617 12.397 14.297C12.2617 14.4323 12.096 14.5 11.9 14.5H2.1C1.904 14.5 1.73833 14.4323 1.603 14.297C1.46767 14.1617 1.4 13.996 1.4 13.8V3.3H0V1.9H3.5ZM2.8 3.3V13.1H11.2V3.3H2.8ZM4.9 5.4H6.3V11H4.9V5.4ZM7.7 5.4H9.1V11H7.7V5.4Z",
    fill: "#1E1A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteM);
export default __webpack_public_path__ + "static/media/deleteM.d488a13a0669533c69d5213485161c24.svg";
export { ForwardRef as ReactComponent };